import React from 'react';
import BankAlaplistaContent from './BankAlaplistaContent';

const SzamlaListaBase = (props) => {
  let cardStyle = {
    padding: 20
  };

  return (
    <div className="animated fadeIn">
      <div className="card">
        <div className="card-header">
          {'Bank alaplista'}
        </div>
        <div className="row" style={cardStyle}>
          <div className="col-md-12">
            <BankAlaplistaContent
              globals={props.route.globals}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SzamlaListaBase;
